export const GET_LIST_CASE_DASHBOARD_ASYNC = 'GET_LIST_CASE_DASHBOARD_ASYNC'
export const GET_LIST_CASE_DASHBOARD_SUCCESS = 'GET_LIST_CASE_DASHBOARD_SUCCESS'
export const GET_LIST_CASE_DASHBOARD_FAIL = 'GET_LIST_CASE_DASHBOARD_FAIL'

export const GET_TRACK_REQUEST_DASHBOARD_ASYNC = 'GET_TRACK_REQUEST_DASHBOARD_ASYNC'
export const GET_TRACK_REQUEST_DASHBOARD_SUCCESS = 'GET_TRACK_REQUEST_DASHBOARD_SUCCESS'
export const GET_TRACK_REQUEST_DASHBOARD_FAIL = 'GET_TRACK_REQUEST_DASHBOARD_FAIL'
